@if (access$ | async; as access) {
  <div class="dca-heading flex items-center justify-between px2">
    <div class="h2">Authors</div>
    <div class="flex items-center">
      <button
        (click)="ref.emit({ action: 'new_author' })"
        mat-icon-button
        matTooltip="Add author without document access"
        matTooltipPosition="below"
        matTooltipShowDelay="200"
        matTooltipHideDelay="300"
      >
        <mat-icon>playlist_add</mat-icon>
      </button>
    </div>
  </div>
}
